<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-form ref="form" :inline="true" :model="searcheModel">
                <el-form-item label="录单时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="客户名称" class="customer-input" >
                    <CustomerSelect ref="CustomerSelect" :customerIdss="searcheModel.customer_name" v-model="searcheModel.customer_name" @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <!-- <el-form-item label="所属部门">
                    <UserCascader
                        v-model="searcheModel.branch_id"
                        ref="branch"
                        :isBusiness="true"
                        @change="changeBranch($event, 'branch_id')"
                    ></UserCascader>
                </el-form-item> -->
                <el-form-item label="试用订单所属部门">
                    <UserCascader
                        v-model="searcheModel.try_order_branch_id"
                        ref="branch"
                        :isBusiness="true"
                        @change="changeBranch($event, 'try_order_branch_id')"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="试用订单负责人">
                    <OrderUserSelect ref="user1" :uid="searcheModel.try_order_user_id" @change="CorpHandleChange($event, 'try_order_user_id')" clearable key="1"></OrderUserSelect>
                </el-form-item>
                <el-form-item label="绑定业务员">
                    <OrderUserSelect ref="user2" :uid="searcheModel.user_id" @change="CorpHandleChange($event, 'user_id')" clearable key="2"></OrderUserSelect>
                </el-form-item>
                <el-form-item label="产品类型">
                    <Product ref="product" :product_id="searcheModel.product_id"
                    @change="productChange"></Product>
                </el-form-item>
                <el-form-item label="财务审核">
                    <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="试用转化分析" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>

            <div>
                <p style="color:#85CE61;">
                    统计数据同步时间：7:00<br>
                    数据不能超过50000条
                </p>
            </div>

            <el-row :gutter="40" class="addBtn" justify="center" v-loading="loading">
                <el-col :span="4" :offset="5">
                    <div class="grid-content">
                    <p>试用客户数</p>
                    <p>{{count_data.try_customer_num}}</p>
                    </div>
                </el-col>
                <el-col :span="4" :offset="1">
                    <div class="grid-content">
                    <p>试用订单数</p>
                    <p>{{count_data.try_order_num}}</p>
                    </div>
                </el-col>
                <el-col :span="4" :offset="1">
                    <div class="grid-content">
                    <p>正式(新单)数</p>
                    <p>{{count_data.transformed_order_num}}</p>
                    </div>
                </el-col>
            </el-row>
            
            <el-table
                v-if="!loading"
                :data="list" 
                height="600"
                border 
                :header-cell-style="{background: '#f3faff'}"
                @sort-change="submitSearch($event)"
            >
                <el-table-column prop="customer_id" label="客户ID"></el-table-column>
                <el-table-column label="客户名称" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)">
                            {{ scope.row.customer_name }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="area" label="地区" width="160"></el-table-column>
                <el-table-column prop="product_name" label="产品"></el-table-column>
                <el-table-column prop="try_order_num" label="试用订单数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 1)">
                            {{ scope.row.try_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="try_order_user_name" label="试用订单负责人"></el-table-column>
                <el-table-column prop="try_order_branch_name" label="试用订单部门"></el-table-column>
                <el-table-column prop="created_at" label="最新试用录单时间" width="150"></el-table-column>
                <el-table-column prop="download_chid_num" label="最近下载科目" sortable="download_chid_num" width="130"></el-table-column>
                <el-table-column prop="download_num" label="最近下载数" sortable="download_num" width="120"></el-table-column>
                <el-table-column prop="transformed_order_num" label="转化正式(新单)" sortable="transformed_order_num" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 2)">
                            {{ scope.row.transformed_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="new_transformed_order_time" label="最新转化录单时间" width="150"></el-table-column>
                <el-table-column prop="total_amount" label="订单销售额"></el-table-column>
                <el-table-column prop="username" label="绑定业务员"></el-table-column>
                <el-table-column prop="branch_name" label="部门"></el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
        <TryConvOrderDialog v-if="dialogTableVisible" :params="params" @close="closeDialog"></TryConvOrderDialog>
    </div>
</template>
<script>
import GuanbiCount from "~/services/GuanbiCount";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import UserCascader from "~/widgets/UserCascader.vue";
import OrderUserSelect from "~/widgets/OrderUserSelect.vue";
import Product from "~/widgets/Product.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";
import TryConvOrderDialog from "~/views/count/dialog/TryConvOrderDialog.vue";
export default{
    name: 'try',
    
    components: {
        CustomerSelect,
        UserCascader,
        OrderUserSelect,
        Product,
        MyPagination,
        ExportFile,
        Config,
        TryConvOrderDialog
    },

    data() {
        return {
            loading: false,
            searcheModel: {},
            list: [],
            linkPage: null,
            activeName: 'try-conv-analyze',
            dialogTableVisible: false,
            params: {},
            count_data: {}
        };
    },

    created(){
        this.resetForm();
    },
    
    methods: {

        //重置按钮
        resetForm() {
            this.searcheModel = {
                try_order_branch_id: '',
                try_order_user_id: '',
                branch_id: "",
                user_id: "",
                created_at: Config.getDataTimes('to_day'),
                customer_name: '',
                product_id: 2,
                finance_audit: '',
                sort_name: '',
                sort_by: ''
            };
            if(this.$refs['CustomerSelect']){
                this.$refs['CustomerSelect'].reset();
            }
            if(this.$refs['branch2']){
                this.$refs['branch2'].reset();
            }
            if(this.$refs['user1']){
                this.$refs['user1'].reset();
            }
            if(this.$refs['user2']){
                this.$refs['user2'].reset();
            }
            if(this.$refs['product']){
                this.$refs['product'].reset();
            }
            this.list = [];
            this.submitSearch();
        },

        // 筛选查询
        submitSearch($data = null) {
            if($data && typeof $data.order !== undefined){
                this.searcheModel.sort_name = $data['prop'];
                this.searcheModel.sort_by = $data['order'];
            }
            let params = _.clone(this.searcheModel);
            params['page'] = 1;
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getCount(params);
        },

        //获取统计
        getCount(params) {
            // loading 动画
            this.loading = true;
            this.count_data = [];
            GuanbiCount.getCount(params, 'try-conv-count')
            .then((res) => {
                if (res.code == 0) {
                    this.count_data = res.data;
                    this.getList(params);
                }
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            this.list = [];
            GuanbiCount.getCount(params, this.activeName)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (this.list.length > 0 && res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },



        //切换部门子组件
        changeBranch(value, field) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel[field] = value[value.length - 1];
            } else {
                this.searcheModel[field] = "";
            }
        },

        CorpHandleChange($event, field){
            this.searcheModel[field] = $event.id;
        },

        //客户名称远程搜索组件赋值
        CustomerHandleChange(object) {
            this.searcheModel.customer_name = object.value;
        },

        productChange(value) {
            this.searcheModel.product_id = value;
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            let params = this.searcheModel;
            params['perPage'] = newSize;
            this.getList(params);
        },

        handleCurrentChange(newPage) {
            let params = this.searcheModel;
            // 处理当前页码变化事件
            params['page'] = newPage;
            this.getList(params);
        },

        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: row.customer_id },
            });
            window.open(routeData.href, '_blank');
        },

        dialogShow(item, order_type){
            if(order_type == 1 && item.try_order_num == 0 || order_type == 2 && item.transformed_order_num == 0){
                return false;
            }
            this.params = {
                customer_id: item.customer_id,
                product_id: item.product_id,
                try_created_at: item.created_at,
                order_type: order_type,
            };
            this.dialogTableVisible = true;
        },

        closeDialog(){
            this.dialogTableVisible = false;
            this.params = {};
        },
    }
}
</script>
<style scoped>
 .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }

  .grid-content {
    border-radius: 5px;
    min-height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: center; /* 垂直居中 */
    align-items: center; /* 水平居中 */
    background-color: #F2FAFF;
    opacity: 0.94;
    font-size: 16px;
    /* border: 2px solid; */
    font-weight: bolder;
  }
  .addBtn {
    padding: 10px 0;
  }
  .item-title {
    font-size: 16px;
    font-weight: bolder;
  }
</style>


// WEBPACK FOOTER //
// src/views/count/customer/try.vue